import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useLocation, useParams } from 'react-router-dom'
import styled from 'styled-components'
import { ProfileRootType } from '../../@types/auth'
import { IssuableAllCouponType } from '../../@types/coupon'
import { getProfile } from '../../api/auth'
import { getIssuableAllCoupon } from '../../api/coupons'
import { getGuestOrderDetail, getOrderDetail, getOrderList } from '../../api/orderHistory'
import { getMall } from '../../api/product'
import MyChannerlTalk from '../../components/myshopping/MyChannerTalk'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import {
  BuyConfirm,
  CancelDone,
  DeliveryCompleted,
  Delivery_Ing,
  OrderComplete,
  RefundCompleted,
} from '../../components/order/OrderDetailState'
import OrderRecentModal from '../../components/order/OrderRecentModal'
import { useAppContext } from '../../components/provider/AppProvider'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import '../../css/myshopping.css'
import { plusComma } from '../../js/script'

export default function OrderDetail() {
  const [recentModal, setRecentModal] = useState<boolean>(false)
  const [modalSelectAddress, setModalSelectAddress] = useState<any>()
  const [orderItem, setOrderItem] = useState<any>()
  const [load, setLoad] = useState<boolean>(false)
  const [submit, setSubmit] = useState<boolean>(false)
  const [cancelText, setCancelText] = useState<string>('')
  const [orderArray, setOrderArray] = useState<any>([])
  const [stateArray, setStateArray] = useState<any>([])
  const [mallClaim, setMallClaim] = useState<any>([])
  const [claimArray, setClaimArray] = useState<any>([])
  const [orderOptionArray, setOrderOptionArray] = useState<any>([])
  const [allClaim, setAllClaim] = useState<any>([])
  const [delivery, setDelivery] = useState<number>(0)
  const [returnDelivery, setReturnDelivery] = useState<number>(0)
  const [refundMainPayAmt, setRefundMainPayAmt] = useState<number>(0)
  const [refundSubPayAmt, setRefundSubPayAmt] = useState<number>(0)
  const [userData, setUserData] = useState<ProfileRootType>()
  const [mypayCoupon, setMypayCoupon] = useState<IssuableAllCouponType[]>([])
  const [ordersItem, setOrdersItem] = useState<any>()
  const [mypayCount, setMypayCount] = useState<number>(0)
  const { isAppView } = useAppContext()
  const { setIsLottie, hasAccessToken } = useCommonContext()

  const params = useParams()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const guestToken = isAppView ? queryParams.get('guestToken') : location.state?.guestToken

  useEffect(() => {
    if (hasAccessToken) {
      const fetchData = async () => {
        try {
          // 두 가지 비동기 작업을 병렬로 처리
          const [profileRes, couponRes] = await Promise.all([getProfile(), getIssuableAllCoupon()])

          // 프로필 데이터 설정
          setUserData(profileRes.data)

          // 특정 쿠폰을 찾는 로직
          const foundCoupon = couponRes.data.find((el: any) => el.couponName === '어바웃피싱 페이 감사 쿠폰')
          if (foundCoupon) {
            setMypayCoupon(foundCoupon)
          }
        } catch (err) {
          console.error(err)
        }
      }

      fetchData()
    }
  }, [hasAccessToken])

  useEffect(() => {
    if (!hasAccessToken && guestToken) {
      // @ts-ignore
      getGuestOrderDetail(params.orderNo, guestToken)
        .then((res) => {
          setIsLottie(false)
          setOrderItem(res.data)
          setLoad(true)
        })
        .catch((err) => console.log(err))
    } else {
      // @ts-ignore
      getOrderDetail(params.orderNo)
        .then((res) => {
          setIsLottie(false)
          setOrderItem(res.data)
          setLoad(true)
        })
        .catch((err) => console.log(err))
    }
  }, [submit])

  useEffect(() => {
    if (hasAccessToken) {
      getOrderList()
        .then((res) => {
          setOrdersItem(res.data.items)
          setIsLottie(false)
        })
        .catch((err) => console.log(err))
    }
  }, [location])

  useEffect(() => {
    if (ordersItem) {
      let count = 0
      ordersItem.map((el: any) => {
        if (el.pgType === 'MY_PAY') {
          count += 1
        }
      })
      setMypayCount(count)
    }
  }, [ordersItem])

  useEffect(() => {
    getMall().then((res) => {
      setMallClaim(res.data.claimReasonType)
    })
  }, [])

  useEffect(() => {
    if (orderItem && orderItem.claimHistories?.length > 0) {
      const matchedClaim = mallClaim.find(
        (element: any) => orderItem?.claimHistories?.[0].claimReasonType === element.value
      )

      if (matchedClaim) {
        setCancelText(matchedClaim.label)
      }
    }
  }, [orderItem, mallClaim])
  useEffect(() => {
    if (orderItem?.orderOptionsGroupByPartner !== undefined) {
      const orderOptions = orderItem.orderOptionsGroupByPartner[0].orderOptionsGroupByDelivery[0]?.orderOptions || []

      const newOrderOptionArray: any = []
      const newClaimArray: any = []
      const newStateArray: any = []

      orderOptions.forEach((element: any) => {
        newOrderOptionArray.push(element)
        if (element.claimStatusType !== null) {
          newClaimArray.push(element)
        }
        newStateArray.push(element.orderStatusType)
      })

      setOrderOptionArray(newOrderOptionArray)
      setClaimArray(newClaimArray)
      setStateArray(newStateArray)
    }
  }, [orderItem])

  useEffect(() => {
    if (orderItem) {
      let totalProductAmt = 0
      let totalRefundMainPayAmt = 0
      let totalRefundSubPayAmt = 0
      let deliveryBeforeAmt = 0
      let deliveryAfterAmt = 0

      orderItem.refundInfos?.forEach((el: any) => {
        deliveryBeforeAmt = el.deliveryAmtInfo.beforeDeliveryAmt // 마지막 배송 금액 저장
        deliveryAfterAmt = el.deliveryAmtInfo.afterDeliveryAmt // 마지막 반품 배송 금액 저장
        totalProductAmt += el.productAmtInfo.totalAmt // 총 제품 금액 누적
        totalRefundMainPayAmt += el.refundMainPayAmt // 총 환불 주요 금액 누적
        totalRefundSubPayAmt += el.refundSubPayAmt // 총 환불 부가 금액 누적
      })

      // 상태를 한 번에 업데이트
      setDelivery(deliveryBeforeAmt)
      setReturnDelivery(deliveryAfterAmt)
      setRefundMainPayAmt(totalRefundMainPayAmt)
      setRefundSubPayAmt(totalRefundSubPayAmt)
    }
  }, [orderItem])

  useEffect(() => {
    if (stateArray) {
      const uniqueArray = Array.from(new Set(stateArray)) // Set을 사용하여 중복 제거
      setOrderArray(uniqueArray) // 중복이 제거된 배열을 설정
    }
  }, [stateArray])

  useEffect(() => {
    if (claimArray) {
      if (orderOptionArray) {
        if (Number(claimArray.length) === Number(orderOptionArray.length)) {
          setAllClaim(true)
        } else if (Number(claimArray.length) !== Number(orderOptionArray.length)) {
          setAllClaim(false)
        }
      }
    }
  }, [claimArray, orderOptionArray])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>주문 내역 상세</PageTitle>
            <div className='order_detail_wrap'>
              {allClaim && (
                <OrderInfoList>
                  <p>환불 정보</p>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>주문번호</dt>
                    <dd>{orderItem?.orderNo}</dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>환불수단</dt>
                    <dd>
                      {`${
                        orderItem?.payInfo?.cardInfo
                          ? orderItem?.payInfo.cardInfo?.cardName
                            ? orderItem?.payInfo.cardInfo?.cardName
                            : ''
                          : orderItem?.payInfo?.bankInfo
                          ? orderItem?.payInfo?.bankInfo.bankName
                          : ''
                      } ${
                        orderItem?.payInfo?.cardInfo
                          ? orderItem?.payInfo.cardInfo?.cardNo
                            ? orderItem?.payInfo.cardInfo?.cardNo
                            : ''
                          : orderItem?.payInfo?.bankInfo
                          ? orderItem?.payInfo?.bankInfo?.account
                          : ''
                      } ${
                        orderItem?.pgType === 'MY_PAY'
                          ? '마이페이'
                          : orderItem?.pgType === 'KAKAO_PAY'
                          ? '카카오페이'
                          : orderItem?.pgType === 'NAVER_EASY_PAY'
                          ? '(네이버페이)'
                          : ''
                      }`}
                    </dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>반품사유</dt>
                    <dd>{cancelText}</dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>상품 결제 금액</dt>
                    <dd>{plusComma(orderItem?.payInfo?.payAmt)}원</dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>환불 금액</dt>
                    <dd>{plusComma(refundMainPayAmt)}원</dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>환불 적립금</dt>
                    <dd>{plusComma(refundSubPayAmt)}원</dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>환불 배송비</dt>
                    <dd>{plusComma(delivery)}원</dd>
                  </dl>
                  {stateArray.includes('CANCEL_DONE') ? null : (
                    <dl className={!isMobile ? 'left_align' : ''}>
                      <dt>반품배송비</dt>
                      <dd>{plusComma(returnDelivery)}원</dd>
                    </dl>
                  )}
                  <dl className={!isMobile ? 'left_align result_pay' : 'result_pay'}>
                    <dt>예상 환불금액</dt>
                    <dd>{plusComma(refundMainPayAmt)}원</dd>
                  </dl>
                </OrderInfoList>
              )}
              {!allClaim && (
                <OrderInfoList>
                  <p>결제 정보</p>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>주문번호</dt>
                    <dd>{orderItem?.orderNo}</dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>결제일시</dt>
                    <dd>
                      {orderItem?.orderYmdt?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')}{' '}
                      {orderItem?.orderYmdt?.slice(10, 19)}
                    </dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>결제방법</dt>
                    <dd>
                      {orderItem?.payType === 'CREDIT_CARD'
                        ? '신용카드'
                        : orderItem?.payType === 'KAKAO_PAY'
                        ? '카카오페이'
                        : '네이버페이'}
                    </dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>카드정보</dt>
                    <dd>
                      {`${orderItem?.payInfo?.cardInfo?.cardName ? orderItem?.payInfo?.cardInfo?.cardName : ''} ${
                        orderItem?.payInfo?.cardInfo?.cardNo ? orderItem?.payInfo?.cardInfo?.cardNo : ''
                      } ${
                        orderItem?.pgType === 'MY_PAY'
                          ? '마이페이'
                          : orderItem?.pgType === 'KAKAO_PAY'
                          ? '카카오페이'
                          : orderItem?.pgType === 'NAVER_EASY_PAY'
                          ? '(네이버페이)'
                          : ''
                      }`}
                    </dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>정상가</dt>
                    <dd>{plusComma(orderItem?.firstOrderAmount?.standardAmt)}원</dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>상품 할인</dt>
                    <dd>- {plusComma(orderItem?.firstOrderAmount?.immediateDiscountAmt)}원</dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>쿠폰 할인</dt>
                    <dd>
                      {(orderItem?.firstOrderAmount?.cartCouponDiscountAmt as number) +
                      (orderItem?.firstOrderAmount?.productCouponDiscountAmt as number)
                        ? `- 
                  ${plusComma(
                    (orderItem?.firstOrderAmount?.cartCouponDiscountAmt as number) +
                      (orderItem?.firstOrderAmount?.productCouponDiscountAmt as number)
                  )}`
                        : 0}
                      원
                    </dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>적립금 할인</dt>
                    <dd>
                      {orderItem?.firstOrderAmount?.subPayAmt
                        ? `- 
                  ${plusComma(orderItem?.firstOrderAmount?.subPayAmt)}`
                        : 0}
                      원
                    </dd>
                  </dl>
                  <dl className={!isMobile ? 'left_align' : ''}>
                    <dt>배송비</dt>
                    <dd>
                      {orderItem?.firstOrderAmount?.deliveryAmt
                        ? `
                  ${plusComma(orderItem?.firstOrderAmount?.deliveryAmt)}`
                        : 0}
                      원
                    </dd>
                  </dl>

                  <dl className={!isMobile ? 'left_align result_pay' : 'result_pay'}>
                    <dt>결제금액</dt>
                    <dd>{plusComma(orderItem?.firstOrderAmount?.chargeAmt)}원</dd>
                  </dl>
                </OrderInfoList>
              )}

              {allClaim ? null : (
                <>
                  <OrderInfoList>
                    <p>주문자 정보</p>
                    <dl className='left_align gray6'>
                      <dt>주문자</dt>
                      <dd>{orderItem?.orderer?.ordererName}</dd>
                    </dl>
                    {hasAccessToken ? null : (
                      <dl className='left_align gray6'>
                        <dt>이메일</dt>
                        <dd>{orderItem?.orderer?.ordererEmail}</dd>
                      </dl>
                    )}
                    <dl className='left_align gray6'>
                      <dt>휴대폰번호</dt>
                      <dd>{orderItem?.orderer?.ordererContact1?.replaceAll('-', '')}</dd>
                    </dl>
                  </OrderInfoList>

                  <OrderInfoList>
                    <div className='btn_tit_box'>
                      <p>배송지 정보</p>
                    </div>
                    <dl className='left_align gray6'>
                      <dt>받는사람</dt>
                      <dd>{orderItem?.shippingAddress?.receiverName}</dd>
                    </dl>
                    <dl className='left_align gray6'>
                      <dt>휴대폰번호</dt>
                      <dd>{orderItem?.shippingAddress?.receiverContact1?.replaceAll('-', '')}</dd>
                    </dl>
                    <dl className='left_align gray6'>
                      <dt>주소</dt>
                      <dd>{`${orderItem?.shippingAddress?.receiverAddress} ${orderItem?.shippingAddress?.receiverDetailAddress}`}</dd>
                    </dl>
                    <dl className='left_align gray6 bbline'>
                      <dt>배송 메세지</dt>
                      <dd>{orderItem?.deliveryMemo}</dd>
                    </dl>
                    {/* {orderItem?.defaultOrderStatusType === 'PRODUCT_PREPARE' ||
                    orderItem?.defaultOrderStatusType === 'DELIVERY_PREPARE' ? (
                      <button
                        type='button'
                        onClick={() => {
                          const CT = new MyChannerlTalk()
                          CT.boot({
                            pluginKey: '168ab92f-c06e-476b-a2cb-95c54ee01572',
                          })
                          CT.openChat()
                          return () => {
                            CT.shutdown()
                          }
                        }}
                      >
                        1:1 문의하기
                      </button>
                    ) : null} */}
                  </OrderInfoList>
                </>
              )}
              {load ? (
                orderArray.includes('PAY_DONE') ||
                orderArray.includes('PRODUCT_PREPARE') ||
                orderArray.includes('DELIVERY_PREPARE') ? (
                  <OrderComplete el={orderItem}></OrderComplete>
                ) : orderArray.includes('BUY_CONFIRM') ||
                  orderArray.includes('DELIVERY_ING') ||
                  orderArray.includes('DELIVERY_DONE') ||
                  orderItem?.defaultOrderStatusType === 'RETURN_DONE' ? null : (
                  <CancelDone el={orderItem}></CancelDone>
                )
              ) : null}
              {load ? orderArray.includes('DELIVERY_ING') ? <Delivery_Ing el={orderItem}></Delivery_Ing> : null : null}
              {load ? (
                orderArray.includes('DELIVERY_DONE') && !orderArray.includes('BUY_CONFIRM') ? (
                  <DeliveryCompleted
                    el={orderItem}
                    setSubmit={setSubmit}
                    mypayCoupon={mypayCoupon}
                    userData={userData}
                    mypayCount={mypayCount}
                  ></DeliveryCompleted>
                ) : null
              ) : null}

              {load ? (
                orderArray.includes('BUY_CONFIRM') ? (
                  <BuyConfirm
                    el={orderItem}
                    setSubmit={setSubmit}
                    mypayCoupon={mypayCoupon}
                    userData={userData}
                    mypayCount={mypayCount}
                  ></BuyConfirm>
                ) : null
              ) : null}

              {load ? (
                orderItem?.defaultOrderStatusType === 'RETURN_DONE' ? (
                  <RefundCompleted el={orderItem}></RefundCompleted>
                ) : null
              ) : null}

              {recentModal ? (
                <OrderRecentModal
                  setModalSelectAddress={setModalSelectAddress}
                  setIsModal={setRecentModal}
                ></OrderRecentModal>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const OrderInfoList = styled.p`
  padding: 24px 20px;
  border-top: 8px solid var(--colGray1);
  @media screen and (min-width: 768px) {
    border-top: none;
  }
  & .btn_tit_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    & p {
      margin: 0;
    }
    & button {
      font-size: 12px;
      line-height: 16px;
      font-weight: 600;
      color: var(--colGray7);
      padding: 8px 10px;
      border: 1px solid var(--colGray3);
      border-radius: 38px;
      background: transparent;
    }
  }
  & p {
    font-size: 16px;
    line-height: 24px;
    color: var(--colBlack);
    margin-bottom: 16px;
    font-weight: 700;
    @media screen and (min-width: 768px) {
      font-size: 18px;
    }
  }
  & dl {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid var(--colGray3);
    padding: 16px 0;
    & dt {
      font-size: 14px;
      line-height: 18px;
      color: var(--colBlack);
    }
    & dd {
      font-size: 14px;
      line-height: 18px;
      color: var(--colBlack);
    }
    &.save {
      & dt {
        padding-left: 18px;
        position: relative;
        &:before {
          content: '';
          position: absolute;
          top: 2px;
          left: 0;
          background: url('../../images/icon_point.png') no-repeat;
          background-size: contain;
          width: 14px;
          height: 14px;
        }
      }
    }
    &.gray6 {
      & dt {
        color: var(--colGray6);
      }
    }
    &.result_pay {
      padding: 16px 0 0 0;
      & dt {
        font-weight: 700;
      }
      & dd {
        font-size: 18px;
        font-weight: 700;
      }
    }

    &.left_align {
      gap: 20px;
      justify-content: flex-start;
      & dt {
        min-width: 80px;
      }
      & dd {
        width: 100%;
      }
    }
  }
  @media screen and (min-width: 768px) {
    border-top: none;
    &:first-child {
      padding: 32px 0 24px 0;
    }
    padding: 24px 0 24px 0;
    & .btn_tit_box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
      & p {
        margin: 0;
      }
      & button {
        font-size: 12px;
        line-height: 16px;
        font-weight: 600;
        color: var(--colGray7);
        padding: 8px 10px;
        border: 1px solid var(--colGray3);
        border-radius: 38px;
        background: transparent;
      }
    }
    & p {
      font-size: 18px;
      line-height: 24px;
      font-weight: 700;
      color: var(--colBlack);
      margin-bottom: 16px;
    }
    & dl {
      display: flex;
      justify-content: space-between;
      border-top: 1px solid var(--colGray3);
      padding: 16px 0;
      &:last-child {
        border-bottom: 1px solid var(--colGray3);
      }
      & dt {
        font-size: 15px;
        font-weight: 400;
        line-height: 20px;
        color: var(--colBlack);
      }
      & dd {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        color: var(--colBlack);
      }
      &.save {
        & dt {
          padding-left: 18px;
          position: relative;
          &:before {
            content: '';
            position: absolute;
            top: 2px;
            left: 0;
            background: url('../../images/icon_point.png') no-repeat;
            background-size: contain;
            width: 14px;
            height: 14px;
          }
        }
      }
      &.result_pay {
        padding: 16px 0;
        & dt {
          font-weight: 700;
        }
        & dd {
          font-weight: 700;
        }
      }

      &.left_align {
        gap: 20px;
        justify-content: flex-start;
        & dt {
          min-width: 120px;
        }
        & dd {
          width: 100%;
        }
      }
    }
  }
`

export const OrderProduct = styled.p`
  padding: 24px 20px;
  border-top: 8px solid var(--colGray1);
  @media screen and (min-width: 768px) {
    border-top: none;
    padding: 24px 0;
  }
  & .order_product_tit {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--colGray3);
    @media screen and (min-width: 768px) {
      padding-bottom: 20px;
    }
    & div {
      & p {
        font-size: 16px;
        line-height: 24px;
        color: var(--colBlack);
        font-weight: 700;
      }
      & em {
        font-size: 14px;
        line-height: 18px;
        font-style: normal;
        margin-top: 4px;
      }
      @media screen and (min-width: 768px) {
        & p {
          font-size: 18px;
          font-weight: 700;
          line-height: 24px;
          color: var(--colBlack);
        }
        & em {
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          margin-top: 4px;
          display: block;
        }
      }
    }
    & span {
      font-size: 12px;
      line-height: 16px;
      color: var(--colPointBlue);
      padding: 6px 10px;
      border-radius: 38px;
      background: var(--colLightBlue);
      font-weight: 600;
      &.g_color {
        color: var(--colGray7);
        background: var(--colGray2);
      }
      @media screen and (min-width: 768px) {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        padding: 6px 12px;
        &.g_color {
          color: var(--colGray7);
          background: var(--colGray2);
        }
      }
    }
  }

  & .order_item {
    & .g_color {
      & .img_box {
        position: relative;
        max-width: 80px;
        max-height: 80px;
        @media screen and (min-width: 768px) {
          max-width: 100px;
          max-height: 100px;
        }
        &:after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(255, 255, 255, 0.6);
          border-radius: 10px;
        }
      }
      & p {
        color: var(--colGray5) !important;
      }
    }
  }

  & .order_btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-top: 24px;
    & button {
      width: 100%;
      font-size: 14px;
      line-height: 24px;
      color: var(--colBlack);
      text-align: center;
      padding: 11px 0;
      border: 1px solid var(--colGray3);
      border-radius: 5px;
      background: transparent;
      cursor: pointer;
      @media screen and (min-width: 768px) {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
      }
    }
  }

  & .info_txt {
    margin: 16px 0 24px;
    & p {
      font-size: 12px;
      line-height: 18px;
      color: var(--colGray6);
    }
  }
`
